import { Colors } from '@sigma-frontend-libs/commons'
import { EUrlShortenerSettingsDomainsStates } from '@sigmasms/shared-types'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import copyButton from '@/components/button/copy'
import info from '@/components/info'
import selectorOwner from '@/components/selector/owner'
import state from '@/components/services/url-shortener-settings/domains/commons/form/state'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/url-shortener-settings/domains/utils'

function renderNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.name,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.name`),
        hint: this.getTranslate(`${serviceNameViaPoint}.hints.name`),
        error: this.nameValidationError,
        validateOnBlur: true,
        dense: true,
        details: this.isNew,
        autofocus: this.isNew,
        required: true,
        disabled: !this.isNew
      },
      on: {
        input: event => {
          this.proxy.name = event
        }
      }
    }
  )
}
function renderStateField(h) {
  if (!this.isNew) {
    return h(
      state,
      {
        props: {
          value: this.proxy.state,
          disabled: !this.canUpdateDomains,
          required: true
        },
        on: {
          input: event => {
            this.proxy.state = event
          }
        }
      }
    )
  }
}

function renderTXTField(h) {
  return h(
    components.textarea,
    {
      props: {
        value: this.proxy.txt,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.txt`),
        dense: true,
        details: false,
        readonly: true,
        grow: true,
        rows: 4
      }
    }
  )
}
function renderCheckDNSButton(h) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: icons.refresh,
        color: Colors.primary,
        tooltip: this.getTranslate(`${serviceNameViaPoint}.tooltips.check.DNS`),
        loading: this.checkDNSLoading,
        disabled: !this.canCheckDNS
      },
      on: {
        click: () => {
          this.checkDNS(this.value.id)
        }
      }
    }
  )
}
function renderCopyTXTButton(h) {
  return h(
    copyButton,
    {
      props: {
        value: this.proxy.txt,
        tooltip: this.getTranslate(`${serviceNameViaPoint}.tooltips.copy.TXT`)
      }
    }
  )
}
function renderButtons(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form__row-buttons`
    },
    [
      renderCheckDNSButton.call(this, h),
      renderCopyTXTButton.call(this, h)
    ]
  )
}
function renderTXTContent(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form__row`
    },
    [
      renderTXTField.call(this, h),
      renderButtons.call(this, h)
    ]
  )
}
function renderTXTInfo(h) {
  if (this.proxy.state === EUrlShortenerSettingsDomainsStates.pending) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${serviceNameViaPoint}.infos.txt`)
        }
      }
    )
  }
}
function renderTXT(h) {
  if (!this.isNew) {
    return h(
      'div',
      {
        class: `${serviceNameKebabCase}-form__column`
      },
      [
        renderTXTContent.call(this, h),
        renderTXTInfo.call(this, h)
      ]
    )
  }
}

function renderOwnerIdField(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.ownerId,
        disabled: !this.isNew,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}

function renderInfo(h) {
  if (this.isNew) {
    return h(
      info,
      {
        props: {
          // https://sigmasms.slack.com/archives/C073ZQ5H5UY/p1770209128163209?thread_ts=1770202541.680959&cid=C073ZQ5H5UY
          // https://sigmasms.slack.com/archives/C073ZQ5H5UY/p1770209386196069?thread_ts=1770202541.680959&cid=C073ZQ5H5UY
          value: this.getTranslate(`${serviceNameViaPoint}.infos.create`, { ip: '51.250.24.45' })
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${serviceNameKebabCase}-form`]: true,
        [`${serviceNameKebabCase}-form--new`]: this.isNew
      }
    },
    [
      renderNameField.call(this, h),
      renderStateField.call(this, h),
      renderTXT.call(this, h),
      renderOwnerIdField.call(this, h),
      renderInfo.call(this, h)
    ]
  )
}
